module.exports = __webpack_public_path__ + "img/icon_certified1.8d6bb848.png";